import { useState } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImageBlob } from "../utils/imageCrop";
import { compressCoverImage } from "../utils/imageCompression";

export default function CoverImageCropModal({
  open,
  imageSrc,
  title = "Crop cover image",
  aspect = 16 / 9,
  fileNamePrefix = "cover",
  onCancel,
  onComplete,
}) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);

  if (!open || !imageSrc) return null;

  const handleConfirm = async () => {
    if (!croppedAreaPixels) return;
    setProcessing(true);
    try {
      const blob = await getCroppedImageBlob(imageSrc, croppedAreaPixels);
      const croppedFile = new File(
        [blob],
        `${fileNamePrefix}_${Date.now()}.jpg`,
        { type: "image/jpeg" }
      );
      let compressedFile = croppedFile;
      try {
        compressedFile = await compressCoverImage(croppedFile);
      } catch {
        compressedFile = croppedFile;
      }
      const previewUrl = URL.createObjectURL(compressedFile);
      onComplete(compressedFile, previewUrl);
    } catch (err) {
      console.error("Cover crop failed:", err);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-[#333333]/60 flex items-center justify-center p-4">
      <div className="peer-home-page-card p-4 w-full max-w-3xl">
        <h2 className="text-lg font-semibold text-[#333333] mb-3">{title}</h2>
        <div className="relative w-full h-[50vh] sm:h-[60vh] bg-black rounded-lg overflow-hidden">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(_, pixels) => setCroppedAreaPixels(pixels)}
            cropShape="rect"
            showGrid
          />
        </div>
        <div className="mt-4 flex items-center gap-4">
          <input
            type="range"
            min={1}
            max={3}
            step={0.01}
            value={zoom}
            onChange={(e) => setZoom(parseFloat(e.target.value))}
            className="flex-1"
            aria-label="Zoom"
          />
          <span className="text-sm text-[#777777] shrink-0">Zoom</span>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded bg-[#fff5ef] hover:bg-[#eeeeee] text-[#333333] text-sm"
            onClick={onCancel}
            disabled={processing}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded bg-[#f26522] hover:bg-[#d95518] text-white text-sm disabled:opacity-50"
            onClick={handleConfirm}
            disabled={processing || !croppedAreaPixels}
          >
            {processing ? "Processing..." : "Use image"}
          </button>
        </div>
      </div>
    </div>
  );
}
